/* eslint-disable */
import React, { useEffect, useState, useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import axios from "axios";
import {
  getLatestApplication,
  createNewApplication,
  updateApplication,
  resolveDhdStatus,
} from "../../utils/dhdHelpers";
import { PDFDocument, rgb } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import DhdStatesPricing from "../../components/deliveryPrice/dhd";
import ecotrackCommunes from "../../utils/data_livraison/data_ecotrack.json";
import { ChevronDown, Check } from "lucide-react";
import { extractIdCardData } from "../../utils/NationalIdNumberExtraction.js";

const ProhibitedItemsList = () => {
  const { t, i18n } = useTranslation();
  const [expanded, setExpanded] = useState(true);

  const prohibitedRaw = t(
    "specialOfferPage.validationForm.lists.prohibitedItems",
    { returnObjects: true },
  );
  const nonCompensatedRaw = t(
    "specialOfferPage.validationForm.lists.nonCompensatedItems",
    { returnObjects: true },
  );

  const prohibited = Array.isArray(prohibitedRaw) ? prohibitedRaw : [];
  const nonCompensated = Array.isArray(nonCompensatedRaw)
    ? nonCompensatedRaw
    : [];

  return (
    <div
      dir={i18n.dir()}
      style={{
        borderRadius: 12,
        border: "1px solid rgba(220,38,38,0.15)",
        overflow: "hidden",
        marginBottom: 24,
      }}
    >
      {/* القسم الأحمر - المحظورة */}
      <div
        style={{
          background: "rgba(254,242,242,0.8)",
          borderBottom: "1px solid rgba(220,38,38,0.1)",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px 14px",
            cursor: "pointer",
            userSelect: "none",
          }}
          onClick={() => setExpanded((p) => !p)}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div
              style={{
                width: 26,
                height: 26,
                borderRadius: 8,
                background: "rgba(220,38,38,0.1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#B91C1C"
                strokeWidth="2.5"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
              </svg>
            </div>
            <span style={{ fontSize: 12, fontWeight: 700, color: "#991B1B" }}>
              {t("specialOfferPage.validationForm.lists.prohibitedTitle")}
            </span>
            <span
              style={{
                fontSize: 10,
                fontWeight: 700,
                background: "#FEE2E2",
                color: "#B91C1C",
                padding: "2px 7px",
                borderRadius: 20,
                border: "1px solid rgba(185,28,28,0.2)",
              }}
            >
              {t("specialOfferPage.validationForm.lists.prohibitedCount", {
                count: prohibited.length,
              })}
            </span>
          </div>
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#B91C1C"
            strokeWidth="2.5"
            style={{
              transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.25s",
              flexShrink: 0,
            }}
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </div>

        {expanded && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
              gap: 5,
              padding: "4px 12px 12px",
            }}
          >
            {prohibited.map((item, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  padding: "5px 9px",
                  borderRadius: 8,
                  background: "rgba(255,255,255,0.7)",
                  border: "1px solid rgba(220,38,38,0.12)",
                  fontSize: 11,
                  color: "#7F1D1D",
                  lineHeight: 1.4,
                }}
              >
                <div
                  style={{
                    width: 5,
                    height: 5,
                    borderRadius: "50%",
                    background: "#EF4444",
                    flexShrink: 0,
                  }}
                />
                {item}
              </div>
            ))}
            {/* بند الـ 150,000 دج */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                padding: "5px 9px",
                borderRadius: 8,
                background: "rgba(254,226,226,0.6)",
                border: "1px solid rgba(185,28,28,0.2)",
                fontSize: 11,
                color: "#7F1D1D",
                lineHeight: 1.4,
                gridColumn: "span 2",
              }}
            >
              <div
                style={{
                  width: 5,
                  height: 5,
                  borderRadius: "50%",
                  background: "#EF4444",
                  flexShrink: 0,
                }}
              />
              {t("specialOfferPage.validationForm.lists.highValueNote", {
                amount: t(
                  "specialOfferPage.validationForm.lists.highValueAmount",
                ),
              })}
            </div>
          </div>
        )}
      </div>

      {/* القسم الأصفر - غير قابلة للتعويض */}
      <div style={{ background: "rgba(255,251,235,0.8)" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            padding: "10px 14px",
          }}
        >
          <div
            style={{
              width: 26,
              height: 26,
              borderRadius: 8,
              background: "rgba(217,119,6,0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <svg
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#92400E"
              strokeWidth="2.5"
            >
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </div>
          <span style={{ fontSize: 12, fontWeight: 700, color: "#78350F" }}>
            {t("specialOfferPage.validationForm.lists.nonCompensatedTitle")}
          </span>
          <span
            style={{
              fontSize: 10,
              fontWeight: 700,
              background: "#FEF3C7",
              color: "#92400E",
              padding: "2px 7px",
              borderRadius: 20,
              border: "1px solid rgba(146,64,14,0.2)",
            }}
          >
            {t("specialOfferPage.validationForm.lists.nonCompensatedCount", {
              count: nonCompensated.length,
            })}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 5,
            padding: "0 12px 12px",
          }}
        >
          {nonCompensated.map((item, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 5,
                padding: "4px 10px",
                borderRadius: 20,
                background: "rgba(255,255,255,0.7)",
                border: "1px solid rgba(217,119,6,0.2)",
                fontSize: 11,
                color: "#78350F",
              }}
            >
              <div
                style={{
                  width: 5,
                  height: 5,
                  borderRadius: "50%",
                  background: "#F59E0B",
                  flexShrink: 0,
                }}
              />
              {item}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const ValidationDhd = ({ onStatusChange }) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const labelDir = isRTL ? "rtl" : "ltr";
  const inputDir = isRTL ? "rtl" : "ltr";
  const tr = (key) => t(`specialOfferPage.validationForm.${key}`);
  const user = useSelector((state) => state.userReducer.user);
  const account = useSelector((state) => state.AccountReducer || {});
  const [currentStep, setCurrentStep] = useState(1);
  const [acceptDHD, setAcceptDHD] = useState(false);
  const [idCardFront, setIdCardFront] = useState(null);
  const [idCardBack, setIdCardBack] = useState(null);
  const [idCardFrontPreview, setIdCardFrontPreview] = useState(null);
  const [idCardBackPreview, setIdCardBackPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [errors, setErrors] = useState({});
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploadingFile, setIsUploadingFile] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(true);
  const isSubmittingRef = useRef(false);
  const [successData, setSuccessData] = useState({
    idCardFrontUrl: "",
    idCardBackUrl: "",
    registrationFormUrl: "",
    status: "pending",
  });

  // step 3: form fields
  const [clientForm, setClientForm] = useState({
    fullName: "",
    address: "",
    commune: "",
    wilaya: "",
    wilaya_code: "",
    phonePerso: "",
    phonePro: "",
    email: "",
    boutiqueName: "",
    produit: "",
    nationalId: "",
    formDate: new Date().toISOString().slice(0, 10),
  });

  const [wilayaOpen, setWilayaOpen] = useState(false);
  const [communeOpen, setCommuneOpen] = useState(false);
  const wilayas = Array.isArray(DhdStatesPricing) ? DhdStatesPricing : [];

  const communesForWilaya = (() => {
    if (!clientForm.wilaya_code) return [];
    const id = Number(clientForm.wilaya_code);
    return (ecotrackCommunes || []).filter((c) => Number(c.wilaya_id) === id);
  })();

  // national id number extraction
  const [ocrLoading, setOcrLoading] = useState(false);
  const [ocrProgress, setOcrProgress] = useState(0);
  const [ocrResult, setOcrResult] = useState(null);

  // step 4: signature
  const signatureCanvasRef = useRef(null);
  const [hasSignature, setHasSignature] = useState(false);
  const [isDrawing, setIsDrawing] = useState(false);

  const isPdfSource = (file, url) => {
    if (file?.type === "application/pdf") return true;
    if (!url) return false;
    return url.split("?")[0].toLowerCase().endsWith(".pdf");
  };

  const renderFilePreview = ({
    file,
    url,
    alt,
    className,
    clickable = true,
  }) => {
    const source = url || "";
    const isPdf = isPdfSource(file, source);

    if (!source) {
      return (
        <div
          className={`${className} rounded-lg border border-gray-200 dark:!border-[#3c3a3d] bg-white flex items-center justify-center text-gray-400`}
        >
          -
        </div>
      );
    }

    const content = isPdf ? (
      <div
        className={`${className} rounded-lg border border-gray-200 dark:!border-[#3c3a3d] bg-white flex flex-col items-center justify-center gap-2 p-3`}
      >
        <span className="text-4xl">📄</span>
        <span className="text-xs text-[#9e68ba] font-semibold">
          {tr("success.openPdf")}
        </span>
      </div>
    ) : (
      <img
        src={source}
        alt={alt}
        className={`${className} rounded-lg border border-gray-200 dark:!border-[#3c3a3d] bg-white object-contain`}
      />
    );

    if (clickable) {
      return (
        <a href={source} target="_blank" rel="noreferrer" className="block">
          {content}
        </a>
      );
    }

    return content;
  };

  const getStatusClass = (status) => {
    if (status === "approved") return "bg-green-100 text-green-700";
    if (status === "rejected") return "bg-red-100 text-red-700";
    return "bg-amber-100 text-amber-700";
  };

  const upsertProgress = useCallback(
    async (payload = {}) => {
      if (!user) return;
      const data = {
        acceptDHD,
        currentStep,
        finished: false,
        ...payload,
      };

      Object.keys(data).forEach((key) => {
        if (data[key] === undefined) delete data[key];
      });
      await updateApplication(user, user, data);
    },
    [user, acceptDHD, currentStep],
  );

  useEffect(() => {
    if (!wilayaOpen && !communeOpen) return undefined;
    const onDown = (e) => {
      if (
        !e.target.closest?.("[data-wilaya-dropdown]") &&
        !e.target.closest?.("[data-commune-dropdown]")
      ) {
        setWilayaOpen(false);
        setCommuneOpen(false);
      }
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [wilayaOpen, communeOpen]);

  useEffect(() => {
    const init = async () => {
      if (!user) {
        setCheckingStatus(false);
        return;
      }

      try {
        let form = await getLatestApplication(user);
        const status = resolveDhdStatus(form);

        if (!form || status === "none") {
          form = await createNewApplication(user, {
            userEmail: account?.email ?? null,
          });
        }

        setClientForm((prev) => ({
          ...prev,
          wilaya: form.state || prev.wilaya,
          wilaya_code: form.wilaya_code || prev.wilaya_code,
        }));

        if (status === "approved") {
          setSuccessMessage(true);
          setSuccessData({
            idCardFrontUrl: form.idCardFrontUrl || "",
            idCardBackUrl: form.idCardBackUrl || "",
            registrationFormUrl: form.registrationFormUrl || "",
            status: "approved",
          });
          setCheckingStatus(false);
          return;
        }

        setAcceptDHD(!!form.acceptDHD);
        if (isSubmittingRef.current) {
          setCheckingStatus(false);
          return;
        }
        setCurrentStep(
          typeof form.currentStep === "number" && form.currentStep >= 1
            ? Math.min(form.currentStep, 3)
            : 1,
        );
        setSuccessMessage(!!form.finished);

        setSuccessData({
          idCardFrontUrl: form.idCardFrontUrl || "",
          idCardBackUrl: form.idCardBackUrl || "",
          registrationFormUrl: form.registrationFormUrl || "",
          status: form.status || (form.finished ? "pending" : "pending"),
        });
      } catch (error) {
        console.error("Error initializing DHD form:", error);
      } finally {
        setCheckingStatus(false);
      }
    };

    init();
  }, [user]);

  const handlePhoneChange = (key, value) => {
    let cleaned = value.replace(/[^\d+]/g, "");
    if (cleaned.includes("+")) {
      cleaned = "+" + cleaned.replace(/\+/g, "").replace(/[^\d]/g, "");
    }
    setClientForm((p) => ({ ...p, [key]: cleaned }));
  };

  const getCanvas = () => signatureCanvasRef.current;

  const initSignatureCanvas = useCallback(() => {
    const canvas = getCanvas();
    if (!canvas) return;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    const width = canvas.offsetWidth || 400;
    const height = 180;
    canvas.width = width * ratio;
    canvas.height = height * ratio;
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    const ctx = canvas.getContext("2d");
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.scale(ratio, ratio);
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#1a0a00";
    ctx.lineWidth = 2.2;
    ctx.clearRect(0, 0, width, height);
  }, []);

  useEffect(() => {
    if (currentStep === 4) {
      const t = setTimeout(initSignatureCanvas, 50);
      return () => clearTimeout(t);
    }
  }, [currentStep, initSignatureCanvas]);

  const getPointerPos = (e) => {
    const canvas = getCanvas();
    const rect = canvas.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    return {
      x: clientX - rect.left,
      y: clientY - rect.top,
    };
  };

  const startDraw = (e) => {
    e.preventDefault();
    const canvas = getCanvas();
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const { x, y } = getPointerPos(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
    setIsDrawing(true);
  };

  const draw = (e) => {
    if (!isDrawing) return;
    e.preventDefault();
    const canvas = getCanvas();
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const { x, y } = getPointerPos(e);
    ctx.lineTo(x, y);
    ctx.stroke();
    setHasSignature(true);
  };

  const endDraw = () => setIsDrawing(false);

  const clearSignature = () => {
    initSignatureCanvas();
    setHasSignature(false);
  };

  const getSignatureDataUrl = () => {
    const canvas = getCanvas();
    if (!canvas || !hasSignature) return null;
    return canvas.toDataURL("image/png");
  };

  const handleFileUpload = async (
    e,
    setFile,
    setPreview,
    urlKey,
    uploadedKey,
  ) => {
    const file = e.target.files[0];
    if (!file) return;

    const validTypes = ["application/pdf", "image/jpeg", "image/png"];
    if (!validTypes.includes(file.type)) {
      setErrors((prev) => ({
        ...prev,
        fileType: tr("errors.invalidFileType"),
      }));
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      setErrors((prev) => ({ ...prev, fileSize: tr("errors.fileTooLarge") }));
      return;
    }

    setFile(file);
    const reader = new FileReader();
    reader.onloadend = () => setPreview(reader.result);
    reader.readAsDataURL(file);
    setErrors((prev) => ({ ...prev, fileType: "", fileSize: "" }));

    try {
      setIsUploadingFile(true);
      setUploadProgress(0);
      const uploadedUrl = await uploadFileToServer(file);

      setSuccessData((prev) => ({ ...prev, [urlKey]: uploadedUrl }));

      await upsertProgress({
        [urlKey]: uploadedUrl,
        [uploadedKey]: true,
      });
      if (urlKey === "idCardFrontUrl") {
        setOcrLoading(true);
        setOcrProgress(0);
        try {
          const result = await extractIdCardData(file, setOcrProgress);
          if (result.cardNumber) {
            setClientForm((p) => ({ ...p, nationalId: result.cardNumber }));
          }
        } catch (err) {
          console.error("OCR failed:", err);
        } finally {
          setOcrLoading(false);
          setOcrProgress(0);
        }
      }
    } catch (error) {
      console.error("Error saving uploaded file:", error);
      setErrors((prev) => ({ ...prev, submit: tr("errors.submitFailed") }));
    } finally {
      setIsUploadingFile(false);
      setUploadProgress(0);
    }
  };

  const validateStep1 = () => {
    if (!acceptDHD) {
      setErrors({ step1: tr("errors.mustAcceptTerms") });
      return false;
    }
    setErrors({});
    return true;
  };

  const validateStep2 = () => {
    const newErrors = {};
    if (!idCardFront && !successData.idCardFrontUrl)
      newErrors.idCardFront = tr("errors.frontRequired");
    if (!idCardBack && !successData.idCardBackUrl)
      newErrors.idCardBack = tr("errors.backRequired");

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return false;
    }
    setErrors({});
    return true;
  };

  const validateStep3 = () => {
    const required = [
      "fullName",
      "address",
      "commune",
      "wilaya",
      "phonePerso",
      "email",
      "boutiqueName",
      "nationalId",
    ];
    const newErrors = {};
    required.forEach((key) => {
      if (!String(clientForm[key] || "").trim()) {
        newErrors[key] = tr("errors.fieldRequired");
      }
    });
    if (
      clientForm.email &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(clientForm.email)
    ) {
      newErrors.email = tr("errors.invalidEmail");
    }
    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return false;
    }
    setErrors({});
    return true;
  };

  const validateStep4 = () => {
    const newErrors = {};
    if (!hasSignature) {
      newErrors.signature = tr("errors.signatureRequired");
    }
    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return false;
    }
    setErrors({});
    return true;
  };

  const handleNextStep = async () => {
    let isValid = false;
    if (currentStep === 1) isValid = validateStep1();
    else if (currentStep === 2) isValid = validateStep2();
    else if (currentStep === 3) isValid = validateStep3();
    else if (currentStep === 4) isValid = validateStep4();

    if (!isValid) return;

    if (currentStep === 4) {
      await handleSubmit();
      return;
    } else {
      const nextStep = currentStep + 1;
      setCurrentStep(nextStep);

      const payload = { currentStep: nextStep };
      if (currentStep === 3) {
        payload.clientForm = clientForm;
      }
      await upsertProgress(payload);
    }
  };

  const fillAndUploadRegistrationPdf = async () => {
    const templateBytes = await fetch(
      "/dhd/fiche-des-renseignement-client-e-commerce.pdf",
    ).then((r) => {
      if (!r.ok) throw new Error("Template PDF not found");
      return r.arrayBuffer();
    });

    const pdfDoc = await PDFDocument.load(templateBytes);
    pdfDoc.registerFontkit(fontkit);

    const fontBytes = await fetch("/fonts/PingAR+LT-Regular.otf").then((r) => {
      if (!r.ok) throw new Error("Font not found");
      return r.arrayBuffer();
    });
    const font = await pdfDoc.embedFont(fontBytes, { subset: false });

    const page = pdfDoc.getPages()[0];
    const { height } = page.getSize();
    const fontSize = 12;
    const color = rgb(0.08, 0.08, 0.08);

    const [yy, mm, dd] = (clientForm.formDate || "").split("-");
    const day = dd || "";
    const month = mm || "";
    const year = yy || "";

    const dateY = 188;

    const NUDGE_Y = 30;
    const NUDGE_X = 12;

    const draw = (text, x, yFromTop, size = fontSize) => {
      if (!text) return;
      page.drawText(String(text).slice(0, 90), {
        x: x + NUDGE_X,
        y: height - (yFromTop + NUDGE_Y),
        size,
        font,
        color,
      });
    };

    draw(day, 40, dateY); 
    draw(month, 80, dateY);
    draw(year, 110, dateY);

    draw(clientForm.fullName, 130, 282);
    draw(clientForm.address, 100, 309);
    draw(clientForm.commune, 110, 336);
    draw(clientForm.wilaya, 95, 363);
    draw(clientForm.phonePerso, 150, 390);
    draw(clientForm.phonePro, 450, 390);
    draw(clientForm.email, 95, 417);
    draw(clientForm.boutiqueName, 150, 444);
    draw(clientForm.produit, 95, 471);
    draw(clientForm.nationalId, 155, 498);

    const boxX = 430;
    const boxY = height - 650;
    const boxW = 130;
    const boxH = 58;

    const signatureDataUrl = getSignatureDataUrl();
    if (signatureDataUrl) {
      const pngBytes = await fetch(signatureDataUrl).then((r) =>
        r.arrayBuffer(),
      );
      const pngImage = await pdfDoc.embedPng(pngBytes);
      page.drawImage(pngImage, {
        x: boxX,
        y: boxY,
        width: boxW,
        height: boxH,
      });
    }

    const filledBytes = await pdfDoc.save();
    const blob = new Blob([filledBytes], { type: "application/pdf" });
    const rawEmail = clientForm.email || account?.email || "";
    // safe filename: keep only usable characters
    const emailPart =
      String(rawEmail)
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9@._-]/g, "_") || "user";

    const fileName = `dhd-partner-${emailPart}.pdf`;

    return uploadFileToServer(
      new File([blob], fileName, { type: "application/pdf" }),
    );
  };

  const uploadFileToServer = async (file) => {
    if (!file) return null;
    const formData = new FormData();
    formData.append("upload", file, file.name);

    const response = await axios.post(
      "https://octopus-app-i4ylg.ondigitalocean.app/upload",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            setUploadProgress(
              Math.round((progressEvent.loaded / progressEvent.total) * 100),
            );
          }
        },
      },
    );

    const downloadUrl = response?.data?.url;
    if (!downloadUrl) throw new Error("No URL returned from upload endpoint");
    return downloadUrl;
  };

  const handleSubmit = async () => {
    if (!user) {
      setErrors({ submit: tr("errors.loginRequired") });
      return;
    }

    isSubmittingRef.current = true;
    setLoading(true);
    setCurrentStep(4);
    setUploadProgress(0);

    try {
      let idCardFrontUrl = successData.idCardFrontUrl || null;
      let idCardBackUrl = successData.idCardBackUrl || null;

      if (idCardFront && !idCardFrontUrl)
        idCardFrontUrl = await uploadFileToServer(idCardFront);
      if (idCardBack && !idCardBackUrl)
        idCardBackUrl = await uploadFileToServer(idCardBack);

      const registrationFormUrl = await fillAndUploadRegistrationPdf();

      await updateApplication(user, user, {
        idCardFrontUrl,
        idCardBackUrl,
        registrationFormUrl,
        idCardFrontUploaded: true,
        idCardBackUploaded: true,
        registrationFormUploaded: true,
        clientForm,
        status: "pending",
        finished: true,
        currentStep: 4,
        acceptDHD: true,
        submittedAt: new Date(),
        email: clientForm.email,
        userEmail: account?.email ?? null,
      });

      setSuccessData({
        idCardFrontUrl,
        idCardBackUrl,
        registrationFormUrl,
        status: "pending",
      });
      setSuccessMessage(true);
      onStatusChange?.();
    } catch (error) {
      console.error("Error submitting form:", error);
      setErrors({ submit: tr("errors.submitFailed") });
      setCurrentStep(4);
    } finally {
      setLoading(false);
      setUploadProgress(0);
    }
  };

  return (
    <div className="mt-6" dir={isRTL ? "rtl" : "ltr"}>
      <div className="mb-6 mt-4">
        {checkingStatus ? (
          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-8 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
            <div className="flex justify-center mb-8">
              <div className="flex items-center space-x-4 rtl:space-x-reverse">
                {[1, 2, 3, 4].map((step) => (
                  <div key={step} className="flex items-center">
                    <div className="w-10 h-10 rounded-full bg-gray-200 dark:!bg-gray-700 animate-pulse" />
                    {step < 4 && (
                      <div className="w-16 h-1 mx-2 bg-gray-200 dark:!bg-gray-700 animate-pulse" />
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Icon skeleton */}
            <div className="flex flex-col items-center gap-4 mb-8">
              <div className="w-20 h-20 rounded-full bg-gray-200 dark:!bg-gray-700 animate-pulse" />
              <div className="h-5 w-52 rounded bg-gray-200 dark:!bg-gray-700 animate-pulse" />
              <div className="h-3.5 w-72 rounded bg-gray-200 dark:!bg-gray-700 animate-pulse" />
            </div>
          </div>
        ) : !successMessage ? (
          <div>
            <div className="flex justify-center mb-8">
              <div className="flex items-center space-x-4 rtl:space-x-reverse">
                {[1, 2, 3, 4].map((step) => (
                  <div key={step} className="flex items-center">
                    <div
                      className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold ${
                        currentStep >= step
                          ? "bg-[#9e68ba] text-white"
                          : "bg-gray-200 dark:!bg-gray-700 text-gray-500"
                      }`}
                    >
                      {step}
                    </div>
                    {step < 4 && (
                      <div
                        className={`w-16 h-1 mx-2 ${
                          currentStep > step
                            ? "bg-[#9e68ba]"
                            : "bg-gray-200 dark:!bg-gray-700"
                        }`}
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Step 1: Accept DHD Registration */}
            {currentStep === 1 && (
              <div className="space-y-6">
                <div className="bg-white dark:!bg-[#181819] rounded-xl p-8 border border-purple-100 dark:!border-[#3c3a3d]">
                  <div className="text-center">
                    <div className="w-20 h-20 bg-purple-100 dark:!bg-[#9e68ba] rounded-full mx-auto mb-6 flex items-center justify-center">
                      <span className="text-4xl">✓</span>
                    </div>
                    <h2 className="text-2xl font-bold text-gray-800 dark:!text-white mb-4">
                      {tr("step1.title")}
                    </h2>
                    <p className="text-gray-600 dark:!text-gray-300 mb-8">
                      {tr("step1.description")}
                    </p>

                    <ProhibitedItemsList />

                    <div className="flex items-center justify-center">
                      <label className="flex items-center space-x-3 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={acceptDHD}
                          onChange={async (e) => {
                            const checked = e.target.checked;
                            setAcceptDHD(checked);
                            await upsertProgress({
                              acceptDHD: checked,
                              currentStep,
                              finished: false,
                            });
                          }}
                          className="w-5 h-5 text-[#9e68ba] rounded focus:ring-2"
                        />
                        <span className="text-gray-700 dark:!text-gray-300">
                          {tr("step1.accept")}
                        </span>
                      </label>
                    </div>

                    {errors.step1 && (
                      <p className="text-red-600 dark:!text-red-400 text-sm mt-4">
                        ⚠️ {errors.step1}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* Step 2: Upload ID Card */}
            {currentStep === 2 && (
              <div className="space-y-6">
                <div className="bg-white dark:!bg-[#181819] rounded-xl p-8 border border-purple-100 dark:!border-[#3c3a3d]">
                  <div className="text-center">
                    <div className="w-20 h-20 bg-purple-100 dark:!bg-[#141414] rounded-full mx-auto mb-6 flex items-center justify-center">
                      <span className="text-4xl">📄</span>
                    </div>
                    <h2 className="text-2xl font-bold text-gray-800 dark:!text-white mb-4">
                      {tr("step2.title")}
                    </h2>
                    <p className="text-gray-600 dark:!text-gray-300 mb-8">
                      {tr("step2.description")}
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {/* ID Card Front */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 dark:!text-gray-300 mb-3">
                          {tr("step2.frontLabel")}
                        </label>
                        <div className="border-2 border-dashed border-gray-300 dark:!border-gray-600 rounded-lg p-6 text-center hover:border-[#9e68ba] transition cursor-pointer">
                          <input
                            type="file"
                            accept="image/jpeg,image/png,application/pdf"
                            onChange={(e) =>
                              handleFileUpload(
                                e,
                                setIdCardFront,
                                setIdCardFrontPreview,
                                "idCardFrontUrl",
                                "idCardFrontUploaded",
                              )
                            }
                            className="hidden"
                            id="idCardFront"
                          />
                          <label
                            htmlFor="idCardFront"
                            className="cursor-pointer"
                          >
                            {idCardFrontPreview ||
                            successData.idCardFrontUrl ? (
                              <div className="space-y-3">
                                {renderFilePreview({
                                  file: idCardFront,
                                  url:
                                    idCardFrontPreview ||
                                    successData.idCardFrontUrl,
                                  alt: "Recto pièce d'identité",
                                  className: "w-full h-64",
                                  clickable: false,
                                })}
                                <p className="text-green-600 dark:!text-green-400 font-semibold">
                                  ✓{" "}
                                  {idCardFront
                                    ? idCardFront.name
                                    : tr("success.currentFile")}
                                </p>
                              </div>
                            ) : (
                              <div className="space-y-2">
                                <img
                                  src="/dhd/card-id-front.png"
                                  alt={t("ui.nationalIdExample")}
                                  className="mx-auto w-64 opacity-70 rounded-lg"
                                />
                                <p className="text-gray-600 dark:!text-gray-400">
                                  {tr("upload.clickOrDrag")}
                                </p>
                                <p className="text-xs text-gray-500">
                                  {tr("upload.allowedTypes")}
                                </p>
                              </div>
                            )}
                          </label>
                        </div>
                        {errors.idCardFront && (
                          <p className="text-red-600 dark:!text-red-400 text-sm mt-2">
                            ⚠️ {errors.idCardFront}
                          </p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 dark:!text-gray-300 mb-3">
                          {tr("step2.backLabel")}
                        </label>
                        <div className="border-2 border-dashed border-gray-300 dark:!border-gray-600 rounded-lg p-6 text-center hover:border-[#9e68ba] transition cursor-pointer">
                          <input
                            type="file"
                            accept="image/jpeg,image/png,application/pdf"
                            onChange={(e) =>
                              handleFileUpload(
                                e,
                                setIdCardBack,
                                setIdCardBackPreview,
                                "idCardBackUrl",
                                "idCardBackUploaded",
                              )
                            }
                            className="hidden"
                            id="idCardBack"
                          />
                          <label
                            htmlFor="idCardBack"
                            className="cursor-pointer"
                          >
                            {idCardBackPreview || successData.idCardBackUrl ? (
                              <div className="space-y-3">
                                {renderFilePreview({
                                  file: idCardBack,
                                  url:
                                    idCardBackPreview ||
                                    successData.idCardBackUrl,
                                  alt: "Verso pièce d'identité",
                                  className: "w-full h-64",
                                  clickable: false,
                                })}
                                <p className="text-green-600 dark:!text-green-400 font-semibold">
                                  ✓{" "}
                                  {idCardBack
                                    ? idCardBack.name
                                    : tr("success.currentFile")}
                                </p>
                              </div>
                            ) : (
                              <div className="space-y-2">
                                <img
                                  src="/dhd/card-id-back.png"
                                  alt={t("ui.nationalIdExample")}
                                  className="mx-auto w-64 opacity-70 rounded-lg"
                                />
                                <p className="text-gray-600 dark:!text-gray-400">
                                  {tr("upload.clickOrDrag")}
                                </p>
                                <p className="text-xs text-gray-500">
                                  {tr("upload.allowedTypes")}
                                </p>
                              </div>
                            )}
                          </label>
                        </div>
                        {errors.idCardBack && (
                          <p className="text-red-600 dark:!text-red-400 text-sm mt-2">
                            ⚠️ {errors.idCardBack}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Step 3: Upload Registration Form */}
            {currentStep === 3 && (
              <div className="space-y-6">
                <div className="bg-white dark:!bg-[#181819] rounded-xl p-6 sm:p-8 border border-purple-100 dark:!border-[#3c3a3d]">
                  <div className="text-center mb-8">
                    <div className="w-16 h-16 bg-purple-100 dark:!bg-[#9e68ba]/20 rounded-2xl mx-auto mb-4 flex items-center justify-center">
                      <span className="text-3xl">📝</span>
                    </div>
                    <h2 className="text-xl sm:text-2xl font-bold text-gray-800 dark:!text-white mb-2">
                      {tr("step3.title")}
                    </h2>
                    <p className="text-gray-600 dark:!text-gray-300 text-sm max-w-md mx-auto">
                      {tr("step3.description")}
                    </p>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-start">
                    {/* full name */}
                    <div className="sm:col-span-2">
                      <label
                        className="block text-xs font-bold text-gray-600 dark:!text-gray-400 mb-1.5"
                        dir={labelDir}
                        style={{ textAlign: isRTL ? "right" : "left" }}
                      >
                        {tr("step3.fields.fullName")}
                      </label>
                      <input
                        type="text"
                        value={clientForm.fullName}
                        dir={inputDir}
                        style={{ textAlign: isRTL ? "right" : "left" }}
                        onChange={(e) =>
                          setClientForm((p) => ({
                            ...p,
                            fullName: e.target.value,
                          }))
                        }
                        className="w-full h-11 px-3 rounded-xl border border-gray-200 dark:!border-[#3c3a3d] bg-gray-50 dark:!bg-[#141414] text-sm font-medium focus:outline-none focus:ring-2 focus:ring-[#9e68ba]/40 focus:border-[#9e68ba]"
                        placeholder={tr("step3.placeholders.fullName")}
                      />
                      {errors.fullName && (
                        <p
                          className="text-red-500 text-xs mt-1 text-start"
                          dir={isRTL ? "rtl" : "ltr"}
                        >
                          ⚠️{errors.fullName}
                        </p>
                      )}
                    </div>

                    {/* address */}
                    <div className="sm:col-span-2">
                      <label
                        className="block text-xs font-bold text-gray-600 dark:!text-gray-400 mb-1.5"
                        dir={labelDir}
                        style={{ textAlign: isRTL ? "right" : "left" }}
                      >
                        {" "}
                        {tr("step3.fields.address")}
                      </label>
                      <input
                        type="text"
                        value={clientForm.address}
                        dir={inputDir}
                        style={{ textAlign: isRTL ? "right" : "left" }}
                        onChange={(e) =>
                          setClientForm((p) => ({
                            ...p,
                            address: e.target.value,
                          }))
                        }
                        className="w-full h-11 px-3 rounded-xl border border-gray-200 dark:!border-[#3c3a3d] bg-gray-50 dark:!bg-[#141414] text-sm font-medium focus:outline-none focus:ring-2 focus:ring-[#9e68ba]/40"
                        placeholder={tr("step3.placeholders.address")}
                      />
                      {errors.address && (
                        <p
                          className="text-red-500 text-xs mt-1 text-start"
                          dir={isRTL ? "rtl" : "ltr"}
                        >
                          ⚠️{errors.address}
                        </p>
                      )}
                    </div>

                    {/* wilaya */}
                    <div className="relative" data-wilaya-dropdown>
                      <label
                        className="block text-xs font-bold text-gray-600 dark:!text-gray-400 mb-1.5"
                        dir={labelDir}
                        style={{ textAlign: isRTL ? "right" : "left" }}
                      >
                        {tr("step3.fields.wilaya")}
                      </label>
                      <button
                        type="button"
                        onClick={() => {
                          setWilayaOpen((v) => !v);
                          setCommuneOpen(false);
                        }}
                        className="w-full h-11 rounded-xl px-3 text-sm font-semibold bg-gray-50 dark:!bg-[#141414] border border-gray-200 dark:!border-[#3c3a3d] flex items-center justify-between gap-2 hover:border-purple-200 focus:outline-none focus:ring-2 focus:ring-purple-200"
                        dir={inputDir}
                      >
                        <span
                          className={
                            clientForm.wilaya
                              ? "text-gray-900 dark:!text-white"
                              : "text-gray-400"
                          }
                        >
                          {clientForm.wilaya ||
                            tr("step3.placeholders.selectWilaya")}
                        </span>
                        <ChevronDown
                          size={16}
                          className={`text-gray-400 shrink-0 transition-transform ${wilayaOpen ? "rotate-180" : ""}`}
                        />
                      </button>

                      {wilayaOpen && (
                        <div className="absolute z-[100] left-0 right-0 top-full mt-1.5 rounded-2xl border border-gray-200 dark:!border-[#3c3a3d] bg-white dark:!bg-[#181819] shadow-xl overflow-hidden">
                          <div className="max-h-56 overflow-y-auto overscroll-contain py-1">
                            {wilayas.map((w) => {
                              const selected =
                                clientForm.wilaya_code ===
                                String(w.wilaya_code);
                              return (
                                <button
                                  key={String(w.wilaya_code)}
                                  type="button"
                                  onClick={() => {
                                    setClientForm((p) => ({
                                      ...p,
                                      wilaya: w.name,
                                      wilaya_code: String(w.wilaya_code),
                                      commune: "",
                                    }));
                                    setWilayaOpen(false);
                                  }}
                                  className={`w-full flex items-center justify-between gap-2 px-3 py-2.5 text-sm text-start transition-colors ${
                                    selected
                                      ? "bg-purple-50 dark:!bg-[#9e68ba]/15 text-[#9b59bf] font-bold"
                                      : "text-gray-700 dark:!text-gray-300 hover:bg-gray-50 dark:hover:bg-[#2a2a2a]"
                                  }`}
                                >
                                  <span>
                                    <span className="text-gray-400 font-mono text-xs me-2">
                                      {w.wilaya_code}
                                    </span>
                                    {w.name}
                                  </span>
                                  {selected && (
                                    <Check
                                      size={14}
                                      className="text-[#9b59bf]"
                                    />
                                  )}
                                </button>
                              );
                            })}
                          </div>
                        </div>
                      )}
                      {errors.wilaya && (
                        <p
                          className="text-red-500 text-xs mt-1 text-start"
                          dir={isRTL ? "rtl" : "ltr"}
                        >
                          ⚠️{errors.wilaya}
                        </p>
                      )}
                    </div>

                    {/* commune */}
                    <div className="relative" data-commune-dropdown>
                      <label
                        className="block text-xs font-bold text-gray-600 dark:!text-gray-400 mb-1.5"
                        dir={labelDir}
                        style={{ textAlign: isRTL ? "right" : "left" }}
                      >
                        {tr("step3.fields.commune")}
                      </label>
                      <button
                        type="button"
                        disabled={!clientForm.wilaya_code}
                        onClick={() => {
                          if (!clientForm.wilaya_code) return;
                          setCommuneOpen((v) => !v);
                          setWilayaOpen(false);
                        }}
                        className={`w-full h-11 rounded-xl px-3 text-sm font-semibold border flex items-center justify-between gap-2 focus:outline-none focus:ring-2 focus:ring-purple-200 ${
                          clientForm.wilaya_code
                            ? "bg-gray-50 dark:!bg-[#141414] border-gray-200 dark:!border-[#3c3a3d] hover:border-purple-200"
                            : "bg-gray-100 dark:!bg-[#1a1a1a] border-gray-200 dark:!border-[#3c3a3d] opacity-60 cursor-not-allowed"
                        }`}
                        dir={inputDir}
                      >
                        <span
                          className={
                            clientForm.commune
                              ? "text-gray-900 dark:!text-white"
                              : "text-gray-400"
                          }
                        >
                          {clientForm.commune ||
                            (clientForm.wilaya_code
                              ? tr("step3.placeholders.selectCommune")
                              : tr("step3.placeholders.selectWilayaFirst"))}
                        </span>
                        <ChevronDown
                          size={16}
                          className={`text-gray-400 shrink-0 transition-transform ${communeOpen ? "rotate-180" : ""}`}
                        />
                      </button>

                      {communeOpen && clientForm.wilaya_code && (
                        <div className="absolute z-[100] left-0 right-0 top-full mt-1.5 rounded-2xl border border-gray-200 dark:!border-[#3c3a3d] bg-white dark:!bg-[#181819] shadow-xl overflow-hidden">
                          <div className="max-h-56 overflow-y-auto overscroll-contain py-1">
                            {communesForWilaya.length === 0 ? (
                              <div className="px-3 py-4 text-center text-sm text-gray-400">
                                {tr("step3.placeholders.noCommune")}
                              </div>
                            ) : (
                              communesForWilaya.map((c) => {
                                const label =
                                  isRTL && c.nom_ar ? c.nom_ar : c.nom;
                                const selected = clientForm.commune === c.nom;
                                return (
                                  <button
                                    key={c.code_postal || c.nom}
                                    type="button"
                                    onClick={() => {
                                      setClientForm((p) => ({
                                        ...p,
                                        commune:
                                          (c.nom_ar && c.nom_ar.trim()) ||
                                          c.nom,
                                      }));
                                      setCommuneOpen(false);
                                    }}
                                    className={`w-full flex items-center justify-between gap-2 px-3 py-2.5 text-sm text-start transition-colors ${
                                      selected
                                        ? "bg-purple-50 dark:!bg-[#9e68ba]/15 text-[#9b59bf] font-bold"
                                        : "text-gray-700 dark:!text-gray-300 hover:bg-gray-50 dark:hover:bg-[#2a2a2a]"
                                    }`}
                                  >
                                    <span>{label}</span>
                                    {selected && (
                                      <Check
                                        size={14}
                                        className="text-[#9b59bf]"
                                      />
                                    )}
                                  </button>
                                );
                              })
                            )}
                          </div>
                        </div>
                      )}
                      {errors.commune && (
                        <p
                          className="text-red-500 text-xs mt-1 text-start"
                          dir={isRTL ? "rtl" : "ltr"}
                        >
                          ⚠️{errors.commune}
                        </p>
                      )}
                    </div>
                    {/* phones */}
                    <div>
                      <label
                        className="block text-xs font-bold text-gray-600 dark:!text-gray-400 mb-1.5"
                        dir={labelDir}
                        style={{ textAlign: isRTL ? "right" : "left" }}
                      >
                        {" "}
                        {tr("step3.fields.phonePerso")}
                      </label>
                      <input
                        type="tel"
                        inputMode="tel"
                        value={clientForm.phonePerso}
                        dir="ltr"
                        style={{ textAlign: "left" }}
                        onChange={(e) =>
                          handlePhoneChange("phonePerso", e.target.value)
                        }
                        className="w-full h-11 px-3 rounded-xl border border-gray-200 dark:!border-[#3c3a3d] bg-gray-50 dark:!bg-[#141414] text-sm font-medium focus:outline-none focus:ring-2 focus:ring-[#9e68ba]/40"
                        placeholder={tr("step3.placeholders.phone")}
                      />
                      {errors.phonePerso && (
                        <p
                          className="text-red-500 text-xs mt-1 text-start"
                          dir={isRTL ? "rtl" : "ltr"}
                        >
                          ⚠️{errors.phonePerso}
                        </p>
                      )}
                    </div>

                    <div>
                      <label
                        className="block text-xs font-bold text-gray-600 dark:!text-gray-400 mb-1.5"
                        dir={labelDir}
                        style={{ textAlign: isRTL ? "right" : "left" }}
                      >
                        {" "}
                        {tr("step3.fields.phonePro")}
                      </label>
                      <input
                        type="tel"
                        inputMode="tel"
                        value={clientForm.phonePro}
                        onChange={(e) =>
                          handlePhoneChange("phonePro", e.target.value)
                        }
                        className="w-full h-11 px-3 rounded-xl border border-gray-200 dark:!border-[#3c3a3d] bg-gray-50 dark:!bg-[#141414] text-sm font-medium focus:outline-none focus:ring-2 focus:ring-[#9e68ba]/40"
                        dir="ltr"
                        style={{ textAlign: "left" }}
                      />
                    </div>

                    {/* email */}
                    <div className="sm:col-span-2">
                      <label
                        className="block text-xs font-bold text-gray-600 dark:!text-gray-400 mb-1.5"
                        dir={labelDir}
                        style={{ textAlign: isRTL ? "right" : "left" }}
                      >
                        {" "}
                        {tr("step3.fields.email")}
                      </label>
                      <input
                        type="email"
                        value={clientForm.email}
                        onChange={(e) =>
                          setClientForm((p) => ({
                            ...p,
                            email: e.target.value,
                          }))
                        }
                        className="w-full h-11 px-3 rounded-xl border border-gray-200 dark:!border-[#3c3a3d] bg-gray-50 dark:!bg-[#141414] text-sm font-medium focus:outline-none focus:ring-2 focus:ring-[#9e68ba]/40"
                        dir="ltr"
                        style={{ textAlign: "left" }}
                      />
                      {errors.email && (
                        <p
                          className="text-red-500 text-xs mt-1 text-start"
                          dir={isRTL ? "rtl" : "ltr"}
                        >
                          ⚠️{errors.email}
                        </p>
                      )}
                    </div>

                    {/* boutique */}
                    <div>
                      <label
                        className="block text-xs font-bold text-gray-600 dark:!text-gray-400 mb-1.5"
                        dir={labelDir}
                        style={{ textAlign: isRTL ? "right" : "left" }}
                      >
                        {" "}
                        {tr("step3.fields.boutiqueName")}
                      </label>
                      <input
                        type="text"
                        value={clientForm.boutiqueName}
                        onChange={(e) =>
                          setClientForm((p) => ({
                            ...p,
                            boutiqueName: e.target.value,
                          }))
                        }
                        dir="ltr"
                        style={{ textAlign: "left" }}
                        className="w-full h-11 px-3 rounded-xl border border-gray-200 dark:!border-[#3c3a3d] bg-gray-50 dark:!bg-[#141414] text-sm font-medium focus:outline-none focus:ring-2 focus:ring-[#9e68ba]/40"
                      />
                      {errors.boutiqueName && (
                        <p
                          className="text-red-500 text-xs mt-1 text-start"
                          dir={isRTL ? "rtl" : "ltr"}
                        >
                          ⚠️{errors.boutiqueName}
                        </p>
                      )}
                    </div>

                    {/* produit */}
                    <div>
                      <label
                        className="block text-xs font-bold text-gray-600 dark:!text-gray-400 mb-1.5"
                        dir={labelDir}
                        style={{ textAlign: isRTL ? "right" : "left" }}
                      >
                        {" "}
                        {tr("step3.fields.produit")}
                      </label>
                      <input
                        type="text"
                        value={clientForm.produit}
                        onChange={(e) =>
                          setClientForm((p) => ({
                            ...p,
                            produit: e.target.value,
                          }))
                        }
                        dir={inputDir}
                        style={{ textAlign: isRTL ? "right" : "left" }}
                        className="w-full h-11 px-3 rounded-xl border border-gray-200 dark:!border-[#3c3a3d] bg-gray-50 dark:!bg-[#141414] text-sm font-medium focus:outline-none focus:ring-2 focus:ring-[#9e68ba]/40"
                        placeholder={tr("step3.placeholders.produit")}
                      />
                    </div>

                    {/* national id */}
                    <div className="sm:col-span-2">
                      <label
                        className="block text-xs font-bold text-gray-600 dark:!text-gray-400 mb-1.5"
                        dir={labelDir}
                        style={{ textAlign: isRTL ? "right" : "left" }}
                      >
                        {" "}
                        {tr("step3.fields.nationalId")}
                      </label>
                      <input
                        type="text"
                        value={clientForm.nationalId}
                        onChange={(e) =>
                          setClientForm((p) => ({
                            ...p,
                            nationalId: e.target.value,
                          }))
                        }
                        className="w-full h-11 px-3 rounded-xl border border-gray-200 dark:!border-[#3c3a3d] bg-gray-50 dark:!bg-[#141414] text-sm font-medium focus:outline-none focus:ring-2 focus:ring-[#9e68ba]/40"
                        dir="ltr"
                        style={{ textAlign: "left" }}
                      />
                      {errors.nationalId && (
                        <p
                          className="text-red-500 text-xs mt-1 text-start"
                          dir={isRTL ? "rtl" : "ltr"}
                        >
                          ⚠️{errors.nationalId}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {currentStep === 4 && (
              <div className="space-y-6">
                <div className="bg-white dark:!bg-[#181819] rounded-xl p-6 sm:p-8 border border-purple-100 dark:!border-[#3c3a3d]">
                  <div className="text-center mb-8">
                    <div className="w-16 h-16 bg-purple-100 dark:!bg-[#9e68ba]/20 rounded-2xl mx-auto mb-4 flex items-center justify-center">
                      <span className="text-3xl">✍️</span>
                    </div>
                    <h2 className="text-xl sm:text-2xl font-bold text-gray-800 dark:!text-white mb-2">
                      {tr("step4.title")}
                    </h2>
                    <p className="text-gray-600 dark:!text-gray-300 text-sm max-w-md mx-auto">
                      {tr("step4.description")}
                    </p>
                  </div>

                  <div>
                    <label
                      className="block text-sm font-medium text-gray-700 dark:!text-gray-300 mb-3"
                      dir={isRTL ? "rtl" : "ltr"}
                      style={{ textAlign: isRTL ? "right" : "left" }}
                    >
                      {tr("step4.signatureLabel")}
                    </label>
                    <div className="relative rounded-2xl border-2 border-dashed border-gray-300 dark:!border-[#3c3a3d] bg-gray-50 dark:!bg-[#141414] overflow-hidden">
                      <canvas
                        ref={signatureCanvasRef}
                        className="w-full touch-none cursor-crosshair"
                        style={{ height: 200, display: "block" }}
                        onMouseDown={startDraw}
                        onMouseMove={draw}
                        onMouseUp={endDraw}
                        onMouseLeave={endDraw}
                        onTouchStart={startDraw}
                        onTouchMove={draw}
                        onTouchEnd={endDraw}
                      />
                      {!hasSignature && (
                        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                          <span className="text-sm text-gray-400 font-medium">
                            {tr("step4.signHere")}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="flex items-center justify-between mt-2">
                      <button
                        type="button"
                        onClick={clearSignature}
                        className="text-sm font-semibold text-gray-500 hover:text-red-600 transition"
                      >
                        {tr("step4.clear")}
                      </button>
                      {hasSignature && (
                        <span className="text-xs font-bold text-emerald-600">
                          ✓ {tr("step4.signed")}
                        </span>
                      )}
                    </div>
                    {errors.signature && (
                      <p
                        className="text-red-500 text-xs mt-1 text-end"
                        dir={isRTL ? "rtl" : "ltr"}
                      >
                        ⚠️ {errors.signature}
                      </p>
                    )}
                  </div>

                  <div className="mt-6 rounded-xl bg-amber-50 dark:!bg-[#1a1508] border border-amber-200 dark:!border-amber-900/40 p-4 text-sm text-amber-900 dark:!text-amber-200/90 text-start">
                    <strong>{tr("step4.noteTitle")}</strong>{" "}
                    {tr("step4.noteText")}
                  </div>
                </div>
              </div>
            )}

            {/* General Errors */}
            {errors.submit && (
              <div className="mt-6 bg-red-50 dark:!bg-[#141414] border border-red-200 dark:!border-red-700 rounded-lg p-4">
                <p className="text-red-600 dark:!text-red-400">
                  ⚠️ {errors.submit}
                </p>
              </div>
            )}

            {/* Upload Progress Bar */}
            {uploadProgress > 0 && uploadProgress < 100 && (
              <div className="mt-6 mb-6">
                <div className="flex items-center justify-between mb-2">
                  <p className="text-sm font-medium text-gray-700 dark:!text-gray-300">
                    {tr("upload.uploadingFiles")}
                  </p>
                  <p className="text-sm font-medium text-[#9e68ba]">
                    {uploadProgress}%
                  </p>
                </div>
                <div className="w-full bg-gray-200 dark:!bg-gray-700 rounded-full h-2.5">
                  <div
                    className="bg-[#9e68ba] h-2.5 rounded-full transition-all duration-300"
                    style={{ width: `${uploadProgress}%` }}
                  />
                </div>
              </div>
            )}

            {/* Buttons */}
            <div className="flex gap-4 mt-8 justify-center">
              {currentStep > 1 && (
                <button
                  onClick={async () => {
                    const previousStep = currentStep - 1;
                    setCurrentStep(previousStep);
                    await upsertProgress({
                      currentStep: previousStep,
                      acceptDHD,
                      finished: false,
                    });
                  }}
                  className="px-8 py-3 bg-gray-300 dark:!bg-gray-600 text-gray-800 dark:!text-white rounded-lg font-medium hover:bg-gray-400 dark:!hover:bg-gray-700 transition"
                >
                  → {tr("buttons.previous")}
                </button>
              )}
              <button
                onClick={handleNextStep}
                disabled={loading || isUploadingFile}
                className={`px-8 py-3 rounded-lg font-medium transition ${
                  loading
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-[#9e68ba] text-white hover:bg-[#814a9f]"
                }`}
              >
                {loading
                  ? tr("buttons.processing")
                  : currentStep === 4
                    ? tr("buttons.submit")
                    : tr("buttons.next")}
              </button>
            </div>
          </div>
        ) : (
          // Success Message
          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-8 text-center border border-[#fbf4ff] dark:!border-[#3c3a3d]">
            <div className="mb-6">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 dark:!bg-[#9e68ba] rounded-full mb-4">
                <span className="text-4xl">✓</span>
              </div>
            </div>
            <h2 className="text-3xl font-bold text-gray-800 dark:!text-white mb-3">
              {tr("success.title")}
            </h2>
            <p className="text-gray-600 dark:!text-gray-300 mb-4">
              {tr("success.description")}
            </p>

            <div className="max-w-2xl mx-auto mb-6 text-left bg-gray-50 dark:!bg-[#141414] border border-gray-200 dark:!border-[#3c3a3d] rounded-lg p-4">
              <div className="flex items-center justify-between flex-wrap gap-2 mb-3">
                <span className="text-sm font-semibold text-gray-700 dark:!text-gray-200">
                  {tr("success.statusLabel")}
                </span>
                <span
                  className={`px-3 py-1 rounded-full text-xs font-bold ${getStatusClass(
                    successData.status || "pending",
                  )}`}
                >
                  {tr(`success.statuses.${successData.status || "pending"}`)}
                </span>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                <div>
                  <p className="text-gray-600 dark:!text-gray-300 mb-2">
                    {tr("success.files.front")}
                  </p>
                  {successData.idCardFrontUrl ? (
                    renderFilePreview({
                      file: null,
                      url: successData.idCardFrontUrl,
                      alt: tr("success.files.front"),
                      className: "w-full h-44",
                    })
                  ) : (
                    <div className="h-44 rounded-lg border border-gray-200 dark:!border-[#3c3a3d] bg-white flex items-center justify-center text-gray-400">
                      -
                    </div>
                  )}
                </div>
                <div>
                  <p className="text-gray-600 dark:!text-gray-300 mb-2">
                    {tr("success.files.back")}
                  </p>
                  {successData.idCardBackUrl ? (
                    renderFilePreview({
                      file: null,
                      url: successData.idCardBackUrl,
                      alt: tr("success.files.back"),
                      className: "w-full h-44",
                    })
                  ) : (
                    <div className="h-44 rounded-lg border border-gray-200 dark:!border-[#3c3a3d] bg-white flex items-center justify-center text-gray-400">
                      -
                    </div>
                  )}
                </div>
                <div>
                  <p className="text-gray-600 dark:!text-gray-300 mb-2">
                    {tr("success.files.form")}
                  </p>
                  {successData.registrationFormUrl ? (
                    renderFilePreview({
                      file: null,
                      url: successData.registrationFormUrl,
                      alt: tr("success.files.form"),
                      className: "w-full h-44",
                    })
                  ) : (
                    <div className="h-44 rounded-lg border border-gray-200 dark:!border-[#3c3a3d] bg-white flex items-center justify-center text-gray-400">
                      -
                    </div>
                  )}
                </div>
              </div>
            </div>

            <button
              onClick={() => (window.location.href = "/dashboard")}
              className="px-8 py-3 bg-[#9e68ba] text-white rounded-lg font-medium hover:bg-[#814a9f] transition"
            >
              {tr("success.backToDashboard")}
            </button>

            {successData.status !== "approved" && (
              <button
                onClick={() => {
                  setErrors({});
                  setCurrentStep(2);
                  setSuccessMessage(false);
                }}
                className="ml-3 px-8 py-3 bg-gray-200 dark:!bg-gray-700 text-gray-800 dark:!text-white rounded-lg font-medium hover:bg-gray-300 dark:!hover:bg-gray-600 transition"
              >
                {tr("buttons.editFiles")}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ValidationDhd;
